/**
 * Shared PMV print overlay mount — hides #root so app chrome does not leave a blank band.
 * Reuse for all PMV formal documents (print-engine owned pagination).
 */
import React from 'react';
import ReactDOM from 'react-dom/client';

const OVERLAY_STYLE_ID = 'print-container-pmv-overlay';

export function openPmvPrintOverlay(
  render: (onClose: () => void) => React.ReactElement
): void {
  const appRoot = document.getElementById('root');
  const prevRootDisplay = appRoot?.style.display ?? '';
  const existing = document.getElementById('print-container');
  if (existing) existing.remove();

  const printContainer = document.createElement('div');
  printContainer.id = 'print-container';
  printContainer.style.cssText = [
    'display:block',
    'position:fixed',
    'inset:0',
    'z-index:10000',
    'overflow:auto',
    'background:#e5e7eb',
    'margin:0',
    'padding:0',
  ].join(';');
  document.body.appendChild(printContainer);
  if (appRoot) appRoot.style.display = 'none';

  let printStyle = document.getElementById(OVERLAY_STYLE_ID) as HTMLStyleElement | null;
  if (!printStyle) {
    printStyle = document.createElement('style');
    printStyle.id = OVERLAY_STYLE_ID;
    document.head.appendChild(printStyle);
  }
  printStyle.textContent = `
@media print {
  #print-container {
    position: static !important;
    inset: auto !important;
    overflow: visible !important;
    background: #fff !important;
    height: auto !important;
    width: auto !important;
    z-index: auto !important;
  }
  .no-print, .print-controls { display: none !important; }
}
`;

  let root: ReactDOM.Root | null = null;
  const cleanup = () => {
    root?.unmount();
    if (printContainer.parentNode) document.body.removeChild(printContainer);
    printStyle?.remove();
    if (appRoot) appRoot.style.display = prevRootDisplay;
    window.removeEventListener('afterprint', cleanup);
  };

  root = ReactDOM.createRoot(printContainer);
  root.render(render(cleanup));
  window.addEventListener('afterprint', cleanup);
}
